import { getTimestampFromDateTime } from "../../../helpers/formatDate"
import { ASSET_ACTIVITY_STATUS_OPTIONS } from "../../constants/assetCollectionsStatus"
import AssetTable from "./AssetTable"

export default function CollectionsTable({ data, showModel }) {
  const columns = [
    { header: "FECHA Y HORA", render: (m) => getTimestampFromDateTime(m.asset_collection_report_at) || "N/A" },
    { header: "USUARIO", render: (m) => `${m.user_uid || "-"} - ${m.user_full_name || "-"}` },
    { header: "# DE DOCUMENTO", render: (m) => m.uid || "-" },
    { header: "TIPO DE SOLICITUD", render: () => "Cierre de activos" },
    { 
      header: "ESTADO", 
      render: (m) => {
        const option = ASSET_ACTIVITY_STATUS_OPTIONS[m.status]
        return option ? <div className={option.className}>{option.label}</div> : "-"
      } 
    }
  ]

  return (
    <AssetTable
      data={data}
      showModel={showModel}
      columns={columns}
      emptyMessage="No hay cierres de activos en este momento."
      statusOptions={ASSET_ACTIVITY_STATUS_OPTIONS}
    />
  )
}
